import { PaymentApiClient } from '@fourthwall/services/dist/PaymentApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useInitializeUserPaymentMethodSetupMutation = createMutationHook(
  PaymentApiClient.initializeUserPaymentMethodSetup,
  {
    mutationKey: ['initializeUserPaymentMethodSetup'],
  },
)
